import { convertDate } from '~/helpers/date';
import type { IGetHeaderInfo, IStorekeeperCity } from '~~/shared/interfaces/storekeeper';

export const useStorekeeperStore = defineStore('storekeeper', () => {
	const headerInfo = ref<IGetHeaderInfo | null>(null);
	const virtualCargoList = ref<any | null>([]);
	const storekeeperCargoListSearchByNumber = ref<any | null>([]);
	const currentCargo = ref<any | null>(null);
	const filterRequestsType = ref<null | number>(null);
	const chooseDate = ref<string | undefined>(convertDate(new Date()));
	const abortControllers: Record<string, AbortController> = {};
	const isSearchMode = ref(false);
	const isEditMode = ref(false);
	const isInfoModalOpen = ref(false);

	const abortRequest = (key: string) => {
		if (abortControllers[key]) {
			abortControllers[key].abort();
		}
		abortControllers[key] = new AbortController();
		return abortControllers[key].signal;
	};

	const loading = reactive({
		virtualCargoGetAll: false,
		storekeeperCargoSearchByNumber: false,
		virtualCargoGetById: false
	});

	function $reset() {
		headerInfo.value = null;
		virtualCargoList.value = [];
	}

	const setFilterRequestsType = (type: null | number) => {
		filterRequestsType.value = type;
	};

	const resetCurrentCargo = () => {
		currentCargo.value = null;
	};

	const virtualCargoGetById = async (payload: { id: string }, isNeedLoad = true) => {
		const signal = abortRequest('virtualCargoGetById');
		const { data, status } = await useCustomFetch<IGetHeaderInfo>(
			`/api/VirtualCargo/${payload.id}`,
			{
				method: 'get',
				signal
			},
			{
				setLoading: (load: boolean) => {
					if (isNeedLoad) loading.virtualCargoGetById = load;
				}
			}
		);

		if (status.value === 'success' && data.value) {
			currentCargo.value = data.value;
			// storekeeperCargoListSearchByNumber.value = data.value;
		}

		return { data: data.value, status: status.value };
	};

	const virtualCargoSave = async (payload: any) => {
		const signal = abortRequest('virtualCargoSave');
		const { data, status } = await useCustomFetch<IGetHeaderInfo>(
			'/api/VirtualCargo/save',
			{
				method: 'post',
				body: payload,
				signal
			},
			{
				setLoading: (load: boolean) => {
					// loading.virtualCargoGetAll = load;
				}
			}
		);

		if (status.value === 'success' && data.value) {
			// storekeeperCargoListSearchByNumber.value = data.value;
		}

		return { data: data.value, status: status.value };
	};

	const storekeeperCargoSearchByNumber = async (payload: { number: string }) => {
		const signal = abortRequest('storekeeperCargoSearchByNumber');
		const { data, status } = await useCustomFetch<IGetHeaderInfo>(
			'/api/StorekeeperCargo/search-by-number',
			{
				query: payload,
				signal
			},
			{
				setLoading: (load: boolean) => {
					loading.virtualCargoGetAll = load;
				}
			}
		);

		if (status.value === 'success' && data.value) {
			storekeeperCargoListSearchByNumber.value = data.value;
		}

		return { data: data.value, status: status.value };
	};

	const virtualCargoGetAll = async (isNeedLoader = false) => {
		if (isSearchMode.value || isEditMode.value) return;
		const signal = abortRequest('virtualCargoGetAll');
		const { data, status } = await useCustomFetch<IGetHeaderInfo>(
			'/api/VirtualCargo/get-all',
			{
				query: { filter: filterRequestsType.value, date: chooseDate.value },
				signal
			},
			{
				setLoading: (load: boolean) => {
					if (isNeedLoader) {
						loading.virtualCargoGetAll = load;
					}
				}
			}
		);

		if (status.value === 'success' && data.value) {
			virtualCargoList.value = data.value;
		}

		return { data: data.value, status: status.value };
	};

	const getHeaderInfo = async () => {
		if (isSearchMode.value || isEditMode.value) return;
		const signal = abortRequest('getHeaderInfo');
		const { data, status } = await useCustomFetch<IGetHeaderInfo>('/api/StorekeeperCargo/get-header-info', {
			query: { date: chooseDate.value },
			signal
		});

		if (status.value === 'success' && data.value) {
			headerInfo.value = data.value;
		}

		return { data: data.value, status: status.value };
	};

	const getStorekeeperCitiesLookups = async (payload: { filter: string }) => {
		const { data, status } = await useCustomFetch<IStorekeeperCity[]>(
			'/api/StorekeeperCities/lookups',
			{
				method: 'get',
				query: payload
			},
			{
				setLoading: (load: boolean) => {}
			}
		);

		if (status.value === 'success' && data.value) {
		}
		return { data: data.value, status: status.value };
	};

	return {
		loading,
		headerInfo,
		chooseDate,
		virtualCargoList,
		isSearchMode,
		isEditMode,
		filterRequestsType,
		storekeeperCargoListSearchByNumber,
		currentCargo,
		isInfoModalOpen,
		$reset,
		getHeaderInfo,
		virtualCargoGetAll,
		setFilterRequestsType,
		storekeeperCargoSearchByNumber,
		virtualCargoSave,
		virtualCargoGetById,
		resetCurrentCargo,
		getStorekeeperCitiesLookups
	};
});
